import * as z from 'zod';

export const CreateCustomFieldRequest = z.object({
  field: z
    .object({
      _id: z
        .string()
        .describe('Custom field ID.')
        .regex(
          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
          'Must be a valid GUID'
        )
        .optional()
        .nullable(),
      name: z.string().describe('Custom field title.').min(1).max(150),
      key: z.string().describe('Custom field key.').optional().nullable(),
      defaultPrivacy: z.enum(['UNKNOWN', 'PUBLIC', 'PRIVATE']).optional(),
      fieldType: z
        .enum(['UNKNOWN', 'TEXT', 'NUMBER', 'DATE', 'URL', 'SOCIAL'])
        .optional(),
      socialType: z
        .enum([
          'UNKNOWN',
          'FACEBOOK',
          'INSTAGRAM',
          'LINKEDIN',
          'TWITTER',
          'YOUTUBE',
          'PINTEREST',
          'TIKTOK',
          'DEVIANTART',
          'SOUNDCLOUD',
          'TUMBLR',
          'VIMEO',
          'VKONTAKTE',
          'ODNOKLASSNIKI',
          'OTHER',
        ])
        .optional(),
      fieldOrigin: z
        .enum(['UNKNOWN', 'CUSTOM', 'CONTACT', 'SYSTEM'])
        .optional(),
      appliesTo: z.enum(['ALL_MEMBERS', 'SELECTED_MEMBERS']).optional(),
      section: z
        .enum(['GENERAL', 'SOCIAL', 'DISPLAY_INFO', 'ADDRESS'])
        .optional(),
      _createdDate: z
        .date()
        .describe('Date and time when the field was created.')
        .optional()
        .nullable(),
      _updatedDate: z
        .date()
        .describe('Date and time when the field was updated.')
        .optional()
        .nullable(),
      revision: z
        .string()
        .regex(/^\d+$/, 'Must be a valid UInt64 string')
        .describe(
          'Revision number, which increments by 1 each time the custom field is updated. To prevent conflicting changes, the existing revision must be used when updating a custom field.'
        )
        .optional()
        .nullable(),
    })
    .describe('Custom field to create.'),
});
export const CreateCustomFieldResponse = z.object({
  _id: z
    .string()
    .describe('Custom field ID.')
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    )
    .optional()
    .nullable(),
  name: z
    .string()
    .describe('Custom field title.')
    .min(1)
    .max(150)
    .optional()
    .nullable(),
  key: z.string().describe('Custom field key.').optional().nullable(),
  defaultPrivacy: z
    .enum(['UNKNOWN', 'PUBLIC', 'PRIVATE'])
    .describe('Privacy level of the custom field.')
    .optional(),
  fieldType: z
    .enum(['UNKNOWN', 'TEXT', 'NUMBER', 'DATE', 'URL', 'SOCIAL'])
    .describe('Type of information to provide for members.')
    .optional(),
  socialType: z
    .enum([
      'UNKNOWN',
      'FACEBOOK',
      'INSTAGRAM',
      'LINKEDIN',
      'TWITTER',
      'YOUTUBE',
      'PINTEREST',
      'TIKTOK',
      'DEVIANTART',
      'SOUNDCLOUD',
      'TUMBLR',
      'VIMEO',
      'VKONTAKTE',
      'ODNOKLASSNIKI',
      'OTHER',
    ])
    .describe('Social network type.')
    .optional(),
  fieldOrigin: z
    .enum(['UNKNOWN', 'CUSTOM', 'CONTACT', 'SYSTEM'])
    .describe('Field origin.')
    .optional(),
  appliesTo: z
    .enum(['ALL_MEMBERS', 'SELECTED_MEMBERS'])
    .describe('Which members will have the custom field in their profile.')
    .optional(),
  section: z
    .enum(['GENERAL', 'SOCIAL', 'DISPLAY_INFO', 'ADDRESS'])
    .describe('A section which the field belongs to.')
    .optional(),
  _createdDate: z
    .date()
    .describe('Date and time when the field was created.')
    .optional()
    .nullable(),
  _updatedDate: z
    .date()
    .describe('Date and time when the field was updated.')
    .optional()
    .nullable(),
  revision: z
    .string()
    .regex(/^\d+$/, 'Must be a valid UInt64 string')
    .describe(
      'Revision number, which increments by 1 each time the custom field is updated. To prevent conflicting changes, the existing revision must be used when updating a custom field.'
    )
    .optional()
    .nullable(),
});
export const GetCustomFieldRequest = z.object({
  _id: z
    .string()
    .describe('Custom field ID.')
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    ),
});
export const GetCustomFieldResponse = z.object({
  field: z
    .object({
      _id: z
        .string()
        .describe('Custom field ID.')
        .regex(
          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
          'Must be a valid GUID'
        )
        .optional()
        .nullable(),
      name: z
        .string()
        .describe('Custom field title.')
        .min(1)
        .max(150)
        .optional()
        .nullable(),
      key: z.string().describe('Custom field key.').optional().nullable(),
      defaultPrivacy: z
        .enum(['UNKNOWN', 'PUBLIC', 'PRIVATE'])
        .describe('Privacy level of the custom field.')
        .optional(),
      fieldType: z
        .enum(['UNKNOWN', 'TEXT', 'NUMBER', 'DATE', 'URL', 'SOCIAL'])
        .describe('Type of information to provide for members.')
        .optional(),
      socialType: z
        .enum([
          'UNKNOWN',
          'FACEBOOK',
          'INSTAGRAM',
          'LINKEDIN',
          'TWITTER',
          'YOUTUBE',
          'PINTEREST',
          'TIKTOK',
          'DEVIANTART',
          'SOUNDCLOUD',
          'TUMBLR',
          'VIMEO',
          'VKONTAKTE',
          'ODNOKLASSNIKI',
          'OTHER',
        ])
        .describe('Social network type.')
        .optional(),
      fieldOrigin: z
        .enum(['UNKNOWN', 'CUSTOM', 'CONTACT', 'SYSTEM'])
        .describe('Field origin.')
        .optional(),
      appliesTo: z
        .enum(['ALL_MEMBERS', 'SELECTED_MEMBERS'])
        .describe('Which members will have the custom field in their profile.')
        .optional(),
      section: z
        .enum(['GENERAL', 'SOCIAL', 'DISPLAY_INFO', 'ADDRESS'])
        .describe('A section which the field belongs to.')
        .optional(),
      _createdDate: z
        .date()
        .describe('Date and time when the field was created.')
        .optional()
        .nullable(),
      _updatedDate: z
        .date()
        .describe('Date and time when the field was updated.')
        .optional()
        .nullable(),
      revision: z
        .string()
        .regex(/^\d+$/, 'Must be a valid UInt64 string')
        .describe(
          'Revision number, which increments by 1 each time the custom field is updated. To prevent conflicting changes, the existing revision must be used when updating a custom field.'
        )
        .optional()
        .nullable(),
    })
    .describe('The retrieved custom field.')
    .optional(),
});
export const ListCustomFieldsRequest = z.object({
  options: z
    .object({
      paging: z
        .object({
          limit: z
            .number()
            .int()
            .describe('Number of items to load.')
            .min(0)
            .optional()
            .nullable(),
          offset: z
            .number()
            .int()
            .describe('Number of items to skip in the current sort order.')
            .min(0)
            .optional()
            .nullable(),
        })
        .optional(),
    })
    .optional(),
});
export const ListCustomFieldsResponse = z.object({
  fields: z
    .array(
      z.object({
        _id: z
          .string()
          .describe('Custom field ID.')
          .regex(
            /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
            'Must be a valid GUID'
          )
          .optional()
          .nullable(),
        name: z
          .string()
          .describe('Custom field title.')
          .min(1)
          .max(150)
          .optional()
          .nullable(),
        key: z.string().describe('Custom field key.').optional().nullable(),
        defaultPrivacy: z
          .enum(['UNKNOWN', 'PUBLIC', 'PRIVATE'])
          .describe('Privacy level of the custom field.')
          .optional(),
        fieldType: z
          .enum(['UNKNOWN', 'TEXT', 'NUMBER', 'DATE', 'URL', 'SOCIAL'])
          .describe('Type of information to provide for members.')
          .optional(),
        socialType: z
          .enum([
            'UNKNOWN',
            'FACEBOOK',
            'INSTAGRAM',
            'LINKEDIN',
            'TWITTER',
            'YOUTUBE',
            'PINTEREST',
            'TIKTOK',
            'DEVIANTART',
            'SOUNDCLOUD',
            'TUMBLR',
            'VIMEO',
            'VKONTAKTE',
            'ODNOKLASSNIKI',
            'OTHER',
          ])
          .describe('Social network type.')
          .optional(),
        fieldOrigin: z
          .enum(['UNKNOWN', 'CUSTOM', 'CONTACT', 'SYSTEM'])
          .describe('Field origin.')
          .optional(),
        appliesTo: z
          .enum(['ALL_MEMBERS', 'SELECTED_MEMBERS'])
          .describe(
            'Which members will have the custom field in their profile.'
          )
          .optional(),
        section: z
          .enum(['GENERAL', 'SOCIAL', 'DISPLAY_INFO', 'ADDRESS'])
          .describe('A section which the field belongs to.')
          .optional(),
        _createdDate: z
          .date()
          .describe('Date and time when the field was created.')
          .optional()
          .nullable(),
        _updatedDate: z
          .date()
          .describe('Date and time when the field was updated.')
          .optional()
          .nullable(),
        revision: z
          .string()
          .regex(/^\d+$/, 'Must be a valid UInt64 string')
          .describe(
            'Revision number, which increments by 1 each time the custom field is updated. To prevent conflicting changes, the existing revision must be used when updating a custom field.'
          )
          .optional()
          .nullable(),
      })
    )
    .optional(),
  metadata: z
    .object({
      count: z
        .number()
        .int()
        .describe('Number of items returned in the response.')
        .optional()
        .nullable(),
      offset: z
        .number()
        .int()
        .describe('Offset that was requested.')
        .optional()
        .nullable(),
      total: z
        .number()
        .int()
        .describe('Total number of items that match the query.')
        .optional()
        .nullable(),
      tooManyToCount: z
        .boolean()
        .describe(
          'Flag that indicates the server failed to calculate the `total` field.'
        )
        .optional()
        .nullable(),
    })
    .describe('Metadata for the paginated results.')
    .optional(),
});
export const UpdateCustomFieldRequest = z.object({
  _id: z
    .string()
    .describe('Custom field ID.')
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    ),
  field: z
    .object({
      _id: z
        .string()
        .describe('Custom field ID.')
        .regex(
          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
          'Must be a valid GUID'
        )
        .optional()
        .nullable(),
      name: z
        .string()
        .describe('Custom field title.')
        .min(1)
        .max(150)
        .optional()
        .nullable(),
      key: z.string().describe('Custom field key.').optional().nullable(),
      defaultPrivacy: z.enum(['UNKNOWN', 'PUBLIC', 'PRIVATE']).optional(),
      fieldType: z
        .enum(['UNKNOWN', 'TEXT', 'NUMBER', 'DATE', 'URL', 'SOCIAL'])
        .optional(),
      socialType: z
        .enum([
          'UNKNOWN',
          'FACEBOOK',
          'INSTAGRAM',
          'LINKEDIN',
          'TWITTER',
          'YOUTUBE',
          'PINTEREST',
          'TIKTOK',
          'DEVIANTART',
          'SOUNDCLOUD',
          'TUMBLR',
          'VIMEO',
          'VKONTAKTE',
          'ODNOKLASSNIKI',
          'OTHER',
        ])
        .optional(),
      fieldOrigin: z
        .enum(['UNKNOWN', 'CUSTOM', 'CONTACT', 'SYSTEM'])
        .optional(),
      appliesTo: z.enum(['ALL_MEMBERS', 'SELECTED_MEMBERS']).optional(),
      section: z
        .enum(['GENERAL', 'SOCIAL', 'DISPLAY_INFO', 'ADDRESS'])
        .optional(),
      _createdDate: z
        .date()
        .describe('Date and time when the field was created.')
        .optional()
        .nullable(),
      _updatedDate: z
        .date()
        .describe('Date and time when the field was updated.')
        .optional()
        .nullable(),
      revision: z
        .string()
        .regex(/^\d+$/, 'Must be a valid UInt64 string')
        .describe(
          'Revision number, which increments by 1 each time the custom field is updated. To prevent conflicting changes, the existing revision must be used when updating a custom field.'
        ),
    })
    .describe('Custom field details to update.'),
});
export const UpdateCustomFieldResponse = z.object({
  _id: z
    .string()
    .describe('Custom field ID.')
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    )
    .optional()
    .nullable(),
  name: z
    .string()
    .describe('Custom field title.')
    .min(1)
    .max(150)
    .optional()
    .nullable(),
  key: z.string().describe('Custom field key.').optional().nullable(),
  defaultPrivacy: z
    .enum(['UNKNOWN', 'PUBLIC', 'PRIVATE'])
    .describe('Privacy level of the custom field.')
    .optional(),
  fieldType: z
    .enum(['UNKNOWN', 'TEXT', 'NUMBER', 'DATE', 'URL', 'SOCIAL'])
    .describe('Type of information to provide for members.')
    .optional(),
  socialType: z
    .enum([
      'UNKNOWN',
      'FACEBOOK',
      'INSTAGRAM',
      'LINKEDIN',
      'TWITTER',
      'YOUTUBE',
      'PINTEREST',
      'TIKTOK',
      'DEVIANTART',
      'SOUNDCLOUD',
      'TUMBLR',
      'VIMEO',
      'VKONTAKTE',
      'ODNOKLASSNIKI',
      'OTHER',
    ])
    .describe('Social network type.')
    .optional(),
  fieldOrigin: z
    .enum(['UNKNOWN', 'CUSTOM', 'CONTACT', 'SYSTEM'])
    .describe('Field origin.')
    .optional(),
  appliesTo: z
    .enum(['ALL_MEMBERS', 'SELECTED_MEMBERS'])
    .describe('Which members will have the custom field in their profile.')
    .optional(),
  section: z
    .enum(['GENERAL', 'SOCIAL', 'DISPLAY_INFO', 'ADDRESS'])
    .describe('A section which the field belongs to.')
    .optional(),
  _createdDate: z
    .date()
    .describe('Date and time when the field was created.')
    .optional()
    .nullable(),
  _updatedDate: z
    .date()
    .describe('Date and time when the field was updated.')
    .optional()
    .nullable(),
  revision: z
    .string()
    .regex(/^\d+$/, 'Must be a valid UInt64 string')
    .describe(
      'Revision number, which increments by 1 each time the custom field is updated. To prevent conflicting changes, the existing revision must be used when updating a custom field.'
    )
    .optional()
    .nullable(),
});
export const DeleteCustomFieldRequest = z.object({
  _id: z
    .string()
    .describe('ID of the custom field to delete.')
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    ),
  revision: z
    .string()
    .regex(/^\d+$/, 'Must be a valid UInt64 string')
    .describe('Revision number.'),
});
export const DeleteCustomFieldResponse = z.object({});
export const HideCustomFieldRequest = z.object({
  _id: z
    .string()
    .describe('ID of the custom field to hide.')
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    ),
  revision: z
    .string()
    .regex(/^\d+$/, 'Must be a valid UInt64 string')
    .describe('Revision number.'),
});
export const HideCustomFieldResponse = z.object({});
export const UpdateCustomFieldsOrderRequest = z.object({
  fieldIds: z.array(z.string()).min(1).max(100),
  options: z
    .object({
      section: z
        .enum(['GENERAL', 'SOCIAL', 'DISPLAY_INFO', 'ADDRESS'])
        .optional(),
    })
    .optional(),
});
export const UpdateCustomFieldsOrderResponse = z.object({
  fields: z
    .array(
      z.object({
        _id: z
          .string()
          .describe('Custom field ID.')
          .regex(
            /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
            'Must be a valid GUID'
          )
          .optional()
          .nullable(),
        name: z
          .string()
          .describe('Custom field title.')
          .min(1)
          .max(150)
          .optional()
          .nullable(),
        key: z.string().describe('Custom field key.').optional().nullable(),
        defaultPrivacy: z
          .enum(['UNKNOWN', 'PUBLIC', 'PRIVATE'])
          .describe('Privacy level of the custom field.')
          .optional(),
        fieldType: z
          .enum(['UNKNOWN', 'TEXT', 'NUMBER', 'DATE', 'URL', 'SOCIAL'])
          .describe('Type of information to provide for members.')
          .optional(),
        socialType: z
          .enum([
            'UNKNOWN',
            'FACEBOOK',
            'INSTAGRAM',
            'LINKEDIN',
            'TWITTER',
            'YOUTUBE',
            'PINTEREST',
            'TIKTOK',
            'DEVIANTART',
            'SOUNDCLOUD',
            'TUMBLR',
            'VIMEO',
            'VKONTAKTE',
            'ODNOKLASSNIKI',
            'OTHER',
          ])
          .describe('Social network type.')
          .optional(),
        fieldOrigin: z
          .enum(['UNKNOWN', 'CUSTOM', 'CONTACT', 'SYSTEM'])
          .describe('Field origin.')
          .optional(),
        appliesTo: z
          .enum(['ALL_MEMBERS', 'SELECTED_MEMBERS'])
          .describe(
            'Which members will have the custom field in their profile.'
          )
          .optional(),
        section: z
          .enum(['GENERAL', 'SOCIAL', 'DISPLAY_INFO', 'ADDRESS'])
          .describe('A section which the field belongs to.')
          .optional(),
        _createdDate: z
          .date()
          .describe('Date and time when the field was created.')
          .optional()
          .nullable(),
        _updatedDate: z
          .date()
          .describe('Date and time when the field was updated.')
          .optional()
          .nullable(),
        revision: z
          .string()
          .regex(/^\d+$/, 'Must be a valid UInt64 string')
          .describe(
            'Revision number, which increments by 1 each time the custom field is updated. To prevent conflicting changes, the existing revision must be used when updating a custom field.'
          )
          .optional()
          .nullable(),
      })
    )
    .optional(),
  section: z
    .enum(['GENERAL', 'SOCIAL', 'DISPLAY_INFO', 'ADDRESS'])
    .describe('The section which the fields belong to.')
    .optional(),
});
